import React, { useState, useEffect } from "react";
import axios from "../api/axiosInstance";  // مسیر axiosInstance رو چک کن
import { useNavigate } from "react-router-dom"; // برای هدایت به داشبورد

function Tickets() {
  const [tickets, setTickets] = useState([]);
  const [error, setError] = useState("");
  const navigate = useNavigate();  // استفاده از useNavigate برای بازگشت به داشبورد

  useEffect(() => {
    fetchTickets();
  }, []);

  const fetchTickets = async () => {
    try {
      const response = await axios.get("/Ticket/List");
      setTickets(response.data.data);
    } catch (error) {
      setError("خطا در دریافت اطلاعات تیکت‌ها");
    }
  };

  return (
    <div className="tickets-container">
      {/* دکمه بازگشت به داشبورد */}
      <button className="back-button" onClick={() => navigate("/dashboard")}>
        بازگشت به داشبورد
      </button>

      <h2>بررسی تیکت‌ها</h2>

      {error && <p className="error">{error}</p>}

      <div className="tickets-table">
        <table>
          <thead>
            <tr>
              <th>عنوان تیکت</th>
              <th>پیام</th>
              <th>تاریخ ایجاد</th>
              <th>کاربر</th>
            </tr>
          </thead>
          <tbody>
            {tickets.map((ticket) => (
              <tr key={ticket.id}>
                <td>{ticket.title}</td>
                <td>{ticket.message}</td>
                <td>{new Date(ticket.createdDate).toLocaleString()}</td>
                <td>{ticket.user ? ticket.user : "ناشناس"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Tickets;
